import{ConfigService} from  '../app/services/config.service';
export const appInitializerFn = (config: ConfigService) => {
    return () => {
      
      return config.loadConfig();
    };
  };
  